import { Pathname, To } from 'history';
import { action, computed, makeObservable, observable } from 'mobx';
import { Location, NavigateFunction, NavigateOptions } from 'react-router-dom';

export class RouterStore {
  constructor({
    navigate,
    location,
  }: {
    navigate: NavigateFunction;
    location: Location;
  }) {
    this._navigate = navigate;
    this._location = location;

    makeObservable<RouterStore, '_location'>(this, {
      _location: observable.ref,

      location: computed,

      changeLocation: action,
    });
  }

  private readonly _navigate: NavigateFunction;
  private _location: Location;
  private _prevPathname: Pathname | null = null;

  get location(): Location {
    return this._location;
  }

  get pathname(): Pathname {
    return this._location.pathname;
  }

  get prevPathname(): Pathname | null {
    return this._prevPathname;
  }

  changeLocation = (location: Location): void => {
    if (location.pathname !== this._location.pathname) {
      this._prevPathname = this._location.pathname;
    }

    this._location = location;
  };

  navigate = (to: To, options?: NavigateOptions) => {
    this._navigate(to, options);
  };
}
